<mat-sidenav-container [dir]="dir" fullscreen [class.dark-theme]="isDarkTheme">

    <oase-menu (langEmitter)='selectLocaleAndDir($event)' (themeEmitter)='toggleTheme($event)' *ngIf="isAuth()"></oase-menu>

    <div class="app-content">
        <mat-card appearance="outlined" *ngIf="isAuth()" class="breadcrumb-container">
            <mat-card-content>
                <breadcrumb prefix="{{ 'home.typ' | translate:locale.language }}"></breadcrumb>
            </mat-card-content>
        </mat-card>
        <router-outlet></router-outlet>
    </div>

</mat-sidenav-container>
